export default (client) => {
  return {
    fetchAll(workspaceId = null) {
      const config =
        workspaceId === null ? {} : { params: { workspace_id: workspaceId } }
      return client.get('/templates/', config)
    },
    fetch(slug) {
      return client.get(`/templates/${slug}/`)
    },
    install(workspaceId, templateId) {
      return client.post(`/templates/install/${workspaceId}/${templateId}/`)
    },
    asyncInstall(workspaceId, templateId) {
      return client.post(
        `/templates/install/${workspaceId}/${templateId}/async/`
      )
    },
    deleteInstallation(installationId) {
      return client.delete(`/templates/installations/${installationId}/`)
    },
    syncVokalis(workspaceId) {
      return client.post(`/templates/sync-vokalis/${workspaceId}/`)
    },
  }
}
